// extracted by mini-css-extract-plugin
export default {"errorBoundary":"css-tUuRvC1Zti","errorBoundary_button":"css-clgcJM8Ca4"};